import React, { useState, useEffect } from "react";

import { Container, Row, Col, Form } from "react-bootstrap";
import api from "../../../api";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import {
  CreateRegionRecord,
  FetchRegionById,
  UpdateRegionRecord,
} from "../../../services/locationService";
import arrow_btn from "../../../assets/images/icon/arrow-btn.svg";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import CryptoJS from "crypto-js";
import { GetCompanyData } from "services/CompanyService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const EditRegion = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const { regionId } = useParams();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [Country, setCountry] = useState([]);
  const [statePayload, setStatePayload] = useState({
    status: "1",
  });
  const [countryId, setCountryId] = useState(null);
  const [countryIdSelected, setCountryIdSelected] = useState(false);
  const handleInput = event => {
    const { name, value } = event.target;

    setStatePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

    useEffect(() => {
      GetCompanyData()
        .then(res => {
          let companyData = res?.data?.data || {};
  
          setStatePayload(prevState => ({
            ...prevState,
            country_id: companyData?.country_id,
          }));
  
          setCountryId(companyData?.country_id);
          if (companyData?.country_id) setCountryIdSelected(true);
        })
        .catch(err => {});
      return () => {};
    }, []);

  const handleCountrySelection = CountryID => {
    setStatePayload(prevState => ({
      ...prevState,
      country_id: CountryID,
    }));
    setCountryId(CountryID);
  };



  const editRegion = payload => {
    UpdateRegionRecord(payload, regionId)
      .then(response => {
        setIsLoading(false);
        toast.success(t(`Location_Manager.Region updated`));
        history.push("/region-list");
      })
      .catch(err => {
        setIsLoading(false);

        let msg =
          err?.response?.data?.message ||
          err?.message ||
          t(`Location_Manager.Edit region err`);
        toast.error(msg);

        if (Object.keys(err?.response?.data?.message?.errors || {})?.length) {
          setErrors(err?.response?.data?.message?.errors || {});
        }
      });
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    if (!statePayload?.country_id) {
      errorObj["country_id"] = t(`Location_Manager.Country required`);
    }

    if (!statePayload?.region) {
      errorObj["region"] = t(`Location_Manager.Name required`);
    }

    if (Object.keys(errorObj)?.length > 0) {
      setIsLoading(false);
      setErrors(prevState => ({
        ...prevState,
        ...errorObj,
      }));

      return;
    }

    let reqData = {
      country_id: statePayload?.country_id || countryId,
      region: statePayload?.region,
      status: statePayload?.status,
    };
    let encryptedQuery = encryptDataToArray(reqData);

    let payload = new FormData();

    payload.append("reqData", JSON.stringify(encryptedQuery));

    editRegion(payload);
  };

  const fetchCountryData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/country-list`)
      .then(response => {
        const { success, allCountry } = response.data;
        if (success) {
          const { allCountry } = response.data;
          let data = allCountry?.map(item => ({
            id: item?.id,
            label: item?.name,
            value: item?.name,
          }));
          setCountry(data);
        }
      })
      .catch(err => console.log("Error:::", err));
  };

  const GetRegion = () => {
    FetchRegionById(regionId)
      .then(res => {
        let regionData = res?.data?.data || {};
        // regionData = decryptDataFromArray(regionData);
        setStatePayload(regionData);
        setCountryId(stateData?.country_id);
        setCountryIdSelected(true);
      })
      .catch(err => {});
  };

  useEffect(() => {
    GetRegion();
    fetchCountryData();
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
    if (!checkPermissionStatus("region-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="joblist-container create-vacancy">
        <Row className="mb-3 align-items-center depart-content">
          <Col lg="6" md="6">
            <Link to="/region-list">
              <h5 className="text-uppercase heading-one">
                <img src={arrow_btn} alt="arrow_btn" />
                {t(`Location_Manager.Edit Region`)}
              </h5>
            </Link>
          </Col>
        </Row>
      </div>

      <div className="outerTab-box-wrapper below-vacancy">
        <div className="form-details-section mt-3">
          <Row>
            <Form.Group className="col-md-4 mb-3 floating-label">
              <Form.Label className="float-label">
                {t(`Location_Manager.Country`)}
                <span className="text-danger">*</span>
              </Form.Label>

              <select
                type="select"
                name="country_id"
                className="col-md-6 mb-1 form-control form-select"
                style={{ width: "100%" }}
                onChange={e => handleCountrySelection(e.target?.value)}
                value={Country.find(option => option?.id == countryId)?.id}
                disabled={countryIdSelected === true}
                title={
                  Country.find(option => option?.id == countryId)?.label ||
                  `Please select ${t(`Location_Manager.Country`).toLowerCase()}`
                }
              >
                <option value="" selected>
                  {t(`Location_Manager.Select Country`)}
                </option>
                {Country &&
                  Country.map(el => {
                    return (
                      <option key={el?.value} value={el?.id}>
                        {el?.label}
                      </option>
                    );
                  })}
              </select>
              {errors?.country_id && (
                <small className="text-danger"> {errors?.country_id} </small>
              )}
            </Form.Group>

            <Form.Group className="col-md-4 mb-3 floating-label">
              <Form.Label className="float-label">
                {t(`Location_Manager.Region Name`)}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={t(`Location_Manager.Region`)}
                name="region"
                value={statePayload?.region}
                onChange={handleInput}
                title={`Please enter ${t(
                  `Location_Manager.Region Name`
                ).toLowerCase()}`}
              />
              {errors?.region && (
                <small className="text-danger"> {errors?.region} </small>
              )}
            </Form.Group>

            <Form.Group className="col-md-4 mb-3 floating-label">
              <Form.Label className="float-label">
                {t(`Location_Manager.Status`)}
                <span className="text-danger">*</span>
              </Form.Label>
              <select
                type="select"
                name="status"
                className="col-md-6 mb-1 form-control form-select"
                style={{ width: "100%" }}
                onChange={handleInput}
                value={statePayload?.status}
                title={
                  document.querySelector('select[name="status"]')
                    ?.selectedOptions[0]?.text ||
                  `Please select ${t("Location_Manager.Status").toLowerCase()}`
                }
                onMouseOver={e =>
                  e.target.setAttribute(
                    "title",
                    e.target.selectedOptions[0].text
                  )
                }
              >
                <option value="1">{t(`Location_Manager.Active`)}</option>
                <option value="0">{t(`Location_Manager.Inactive`)}</option>
              </select>
            </Form.Group>
          </Row>

          <Form.Group className="cta text-center d-flex justify-content-start gap-2 mt-4 pb-2">
            <Link
              to="/region-list"
              style={{ marginLeft: "5px" }}
              className="btn btn-secondary"
            >
              {t(`Location_Manager.Cancel`)}
            </Link>
            <ButtonLoader
              title={t(`Location_Manager.Save Details`)}
              variant="primary"
              style={{ marginLeft: "5px" }}
              type="submit"
              loading={isLoading}
              message={t(`Location_Manager.Saving`)}
              onClick={e => {
                handleSubmit(e);
              }}
            />
          </Form.Group>
        </div>
      </div>
    </div>
  );
};

export default EditRegion;
